import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { Cancel } from '@mui/icons-material';

interface PaymentCancelPageProps {
  onBackToProducts: () => void;
  onBackToHome: () => void;
}

export const PaymentCancelPage: React.FC<PaymentCancelPageProps> = ({
  onBackToProducts,
  onBackToHome,
}) => {
  return (
    <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
      <Box
        sx={{
          backgroundColor: '#1a1a1a',
          border: '2px solid #404040',
          borderRadius: 2,
          p: 6,
        }}
      >
        <Cancel sx={{ fontSize: 80, color: '#ff9800', mb: 3 }} />
        
        <Typography variant="h3" gutterBottom sx={{ fontWeight: 700, color: '#c0c0c0' }}>
          Payment Cancelled
        </Typography>

        <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
          Your payment was cancelled and no charges were made
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 6 }}>
          If you experienced any issues during checkout, please try again or contact our support team for assistance.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="outlined"
            size="large"
            onClick={onBackToHome}
            sx={{
              borderColor: '#9b59b6',
              color: '#9b59b6',
              px: 4,
              py: 1.5,
              fontWeight: 600,
              '&:hover': {
                borderColor: '#c74375',
                color: '#c74375',
                backgroundColor: 'rgba(155, 89, 182, 0.1)',
              },
            }}
          >
            Back to Home
          </Button>

          <Button
            variant="contained"
            size="large"
            onClick={onBackToProducts}
            sx={{
              background: 'linear-gradient(135deg, #9b59b6 0%, #c74375 100%)',
              color: '#ffffff',
              px: 4,
              py: 1.5,
              fontWeight: 600,
              '&:hover': {
                background: 'linear-gradient(135deg, #7d3c98 0%, #ad1457 100%)',
              },
            }}
          >
            Try Again
          </Button>
        </Box>
      </Box>
    </Container>
  );
};
